import React from 'react';

import { Box, H3, Link, Separator, Text } from '@betterment/samba-react';

interface Props {
  banAgreementUrl?: string;
  includeSolo401kCopy?: boolean;
}

const TermsAndConditions: React.FC<Props> = ({ banAgreementUrl, includeSolo401kCopy }) => {
  return (
    <Box
      css={{
        border: 'solid 1px',
        borderColor: 'border',
        borderRadius: 'medium',
        padding: 'space.200',
      }}
    >
      <H3 variant="title100">Term and conditions</H3>
      <Separator css={{ my: 'space.150' }} />
      <Text
        as="p"
        css={{
          marginBottom: 'space.150',
        }}
      >
        Betterment&apos;s{' '}
        <Link href="https://www.betterment.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
          privacy policy
        </Link>{' '}
        and{' '}
        <Link
          href="https://betterment-prod-cdn.s3.us-east-1.amazonaws.com/agreements/BettermentAdvisorSolutionsClientAgreements_20251230.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          customer agreements
        </Link>
        , which include the Brokerage Agreement, Advisory Agreement,{' '}
        {includeSolo401kCopy && 'Solo 401(k) Addendum and Trustee Direction, '}
        consent to electronic delivery of documents and written communications, and other important agreements
        {banAgreementUrl && (
          <>
            , as well as the{' '}
            <Link href={banAgreementUrl} target="_blank" rel="noopener noreferrer">
              Betterment Advisor Network terms and conditions
            </Link>
          </>
        )}
        . You also acknowledge that you have received a copy of our{' '}
        <Link href="https://www.betterment.com/adv" target="_blank" rel="noopener noreferrer">
          Form ADV brochure
        </Link>
        . Your advisory agreement and brokerage agreement contain a predispute arbitration clause in Section 37 of the
        Common Provisions of the Customer Agreements on page 25.
      </Text>
    </Box>
  );
};

export default TermsAndConditions;
